import { connect } from 'react-redux';
import get from 'lodash/get';
import {
  getUncachedUrl,
  voiceCreditPercentage,
} from 'selectors/featureToggles';
import {
  getAlertsNavItem,
  getHomeLocation,
} from 'selectors/navigation/mainNav';

import { DEFAULT_XM_LOGO_PATH } from '@xmatters/common/constants/image';

import Header from './Header';

export const mapStateToProps = state => ({
  companyLogoUrl: state.currentOrganization.companyLogoUrl,
  companyName: get(state, 'currentOrganization.info.name'),
  helpId: state.navigation.helpId,
  homeLocation: getHomeLocation(state),
  menuId: state.navigation.menuId,
  showNonProdBanner:
    get(state, 'featureToggles.featureToggleMap.NON_PROD_BANNER') === 'true',
  isReactLoginEnabled:
    get(state, 'featureToggles.featureToggleMap.ENABLE_REACT_USER_LOGIN') ===
    'true',
  user: state.loggedInUser.loggedInUserProfile,
  alertsNavItem: getAlertsNavItem(state),
  voiceCredits: voiceCreditPercentage(state),
  defaultXmLogoPath: getUncachedUrl(state)(DEFAULT_XM_LOGO_PATH),
});

export default connect(mapStateToProps)(Header);
